// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3JvQX","box":"WorkspacesBox_box__3-uyl","node":"WorkspacesBox_node__1r0_X"};